// Base URL for the PHP/MySQL backend (adminhlc-api). Configurable via
// REACT_APP_API_BASE_URL so it can be changed for production without
// touching any component code. Falls back to local XAMPP for dev.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost/adminhlc-api";

// adminhlc-api returns image fields as paths relative to its own origin
// (e.g. "/adminhlc-api/uploads/certificates/xxx.jpeg"), not full URLs.
// This resolves such a path against API_BASE_URL's origin. Already-absolute
// URLs (http/https) are returned unchanged.
export function getImageUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const origin = new URL(API_BASE_URL).origin;
  return `${origin}${path}`;
}
